import useTranslation from 'next-translate/useTranslation'

import LinkNavigation from './LinkNavigation'
import getNavigation from './routes/getNavigation'

function HelpNavigation() {
  const { t } = useTranslation('help')
  const navigation = getNavigation(t)

  return (
    <div className="grid gap-10">
      {navigation.map(({ category, routes }) => (
        <div key={category}>
          <h5 className="mb-8 font-medium text-xs text-gray-75 uppercase">
            {category}
          </h5>
          <ul className="grid gap-8">
            {routes.map(({ name, path }) => (
              <li key={name}>
                <LinkNavigation name={name} href={path} />
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  )
}

export default HelpNavigation
